import { render, staticRenderFns } from "./OccurrenceDetail.vue?vue&type=template&id=7d45ea7b&"
import script from "./OccurrenceDetail.vue?vue&type=script&lang=js&"
export * from "./OccurrenceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OccurrenceDetail.vue"
export default component.exports